import { Component, OnInit } from '@angular/core';
import { AppRedirectService } from './driver-app-redirect.service';

@Component({
    standalone: false,
    selector: 'octo-driver-app-redirect',
    templateUrl: './driver-app-redirect.component.html',
    styleUrls: ['./driver-app-redirect.component.scss'],
})
export class DriverAppRedirectComponent implements OnInit {
    isLoading: boolean = false;

    constructor(private appRedirectService: AppRedirectService) {}

    ngOnInit(): void {
        this.isLoading = true;
        setTimeout(() => {
            this.appRedirectService.redirectToAppStoreOrPlayStore();
            this.isLoading = false;
        }, 1000);
    }
}
